module.exports = __webpack_public_path__ + "assets/group-15.66c12cd0.svg";